import { Injectable } from "@angular/core";
import { ClaimModel } from "../models/role.model";
import { ClaimsService } from "./claims.service";

@Injectable()
export class IdentityService {
    constructor(
        private claimsService: ClaimsService,
    ) {}

    /*
    * I don't think that this is used anywhere.
    */
    getClaims(): Promise<ClaimModel[]> {
        const claims = this.claimsService.getAsKeyValue();
        return Promise.resolve(claims);
    }
}
